import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/logo.svg'
import _imports_1 from '@/assets/img/back-btn.svg'
import _imports_2 from '@/assets/img/cancel-btn-left.svg'
import _imports_3 from '@/assets/img/plus.svg'
import _imports_4 from '@/assets/img/logout.svg'


const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "header-wrapper" }
const _hoisted_3 = { class: "header-logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "header-back" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "header-number" }
const _hoisted_9 = { class: "header-number-text" }
const _hoisted_10 = { class: "header-number-num" }
const _hoisted_11 = { class: "header-menu" }
const _hoisted_12 = { class: "header-menu__wrapper" }
const _hoisted_13 = { class: "header-menu__submenu" }
const _hoisted_14 = {
  key: 0,
  class: "header-menu__dott"
}
const _hoisted_15 = { class: "header-menu__cancel" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "header-actions" }
const _hoisted_20 = { class: "header-actions__wrapper" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_23 = { class: "text" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InformationActionsBtn = _resolveComponent("InformationActionsBtn")!
  const _component_InformationPopup = _resolveComponent("InformationPopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["page-header", { show: _ctx.visibleHeader }])
    }, [
      (_ctx.phone !== '')
        ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "header-back__btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Hide()))
                }, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("header.phone")), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("nav", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "header-menu__link",
                    "active-class": "header-menu__link-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.home")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/offers",
                    class: "header-menu__link",
                    "active-class": "header-menu__link-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.offers")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/options",
                    class: "header-menu__link",
                    "active-class": "header-menu__link-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.service")), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.visibleRefer)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/refer",
                        class: "header-menu__link",
                        "active-class": "header-menu__link-active"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("header.refer")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    to: "/history",
                    class: "header-menu__link",
                    "active-class": "header-menu__link-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.history")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/recharge",
                    class: "header-menu__link",
                    "active-class": "header-menu__link-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.recurrent")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("nav", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/notification",
                    class: "header-menu__sublink",
                    "active-class": "header-menu__sublink-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.notification")) + " ", 1),
                      (_ctx.isHaveNotifications)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/support",
                    class: "header-menu__sublink",
                    "active-class": "header-menu__sublink-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.support")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/setting",
                    class: "header-menu__sublink",
                    "active-class": "header-menu__sublink-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.setting")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/setting/privacy",
                    class: "header-menu__sublink",
                    "active-class": "header-menu__sublink-active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.terms")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    href: _ctx.env().VUE_APP_SITE_URL,
                    class: "cancel-btn"
                  }, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("header.toSite")), 1)
                  ], 8, _hoisted_16)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: "/topup",
                    class: "header-actions__btn btn-orange"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("header.topup")), 1),
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createElementVNode("a", {
                    class: "header-actions__btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ShowLogOutPopup = true))
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("header.logOut")), 1),
                    _hoisted_24
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_InformationPopup, {
      "show-popup": _ctx.ShowLogOutPopup,
      title: _ctx.$t('header.logOutText'),
      hide: _ctx.HideLogOutPopup
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_InformationActionsBtn, {
          name: _ctx.$t('header.yes'),
          onClick: _ctx.Logout
        }, null, 8, ["name", "onClick"]),
        _createVNode(_component_InformationActionsBtn, {
          name: _ctx.$t('header.no'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ShowLogOutPopup = false))
        }, null, 8, ["name"])
      ]),
      _: 1
    }, 8, ["show-popup", "title", "hide"])
  ]))
}